import { FC } from 'react';
import ChartToggle from '../../yoda-ui/components/ChartToggle';
import useContentSwitcher from './ContentSwitcher.hook';
import { buttonSwitcherWrapper, contentSwitcherTitle, contentSwitcherWrapper } from './ContentSwitcher.style';
import { ContentSwitcherPropsType } from './ContentSwitcher.types';
import Box from 'yoda-ui/components/Box';

const ContentSwitcher: FC<ContentSwitcherPropsType> = ({
  primaryContent,
  secondaryContent,
  primaryButtonLabel,
  secondaryButtonLabel,
  primaryTitle,
  secondaryTitle,
  triggerExportCharts,
}) => {
  const { handleChangeContentType, isPrimaryVisible } = useContentSwitcher();

  return (
    <Box sx={ contentSwitcherWrapper }>
      <Box sx={ buttonSwitcherWrapper }>
        <Box sx={ contentSwitcherTitle }>
          {
            isPrimaryVisible
              ? primaryTitle
              : secondaryTitle
          }
        </Box>
        {
          !triggerExportCharts
          && <ChartToggle
            firstButtonName={ primaryButtonLabel }
            secondButtonName={ secondaryButtonLabel }
            onChange={ handleChangeContentType }
          />
        }
      </Box>
      {
        isPrimaryVisible
          ? primaryContent
          : secondaryContent
      }
    </Box>
  );
};

export default ContentSwitcher;
